
import { NavigationMixin, RoutesMixin, TranslationMixin } from '~/mixins'

export default {
  name: 'MobileTheSplashscreen',
  mixins: [NavigationMixin, RoutesMixin, TranslationMixin]
}
